<hpf-about-form
        *ngIf="about"
        [about]="about"
        (create)="onCreate($event)"
    ></hpf-about-form>
<div *ngIf="!about" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>